export var source = "query BillingAndShipping {\n  user {\n    me {\n      shipping {\n        ...Address\n      }\n      billing {\n        ...Address\n      }\n    }\n  }\n}";
import { source as fragment1 } from "../../../helpers/fragments/address.graphql";
var combined = source  + "\n" + fragment1;
export default combined;